import React from 'react';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { Header } from 'src/pages/scheduleSurgery/components/surgery/SurgeryReviewAndSuccess.styled';
import ListView from '../../listView';
import { getTotalCount } from 'src/utils/util';

const ListViewCards = ({
    t,
    sets,
    setImplant,
    setInstrument,
    expandedCard,
    toggleCard,
    handleBundlePopup,
    handleBundleSetItemClick,
    setsQuantityCheck,
    removeCount,
    addCount,
    handleSetItemClick,
    deleteProduct,
    isShippingScreen,
    isReviewSubmitScreen,
    inventoryShipping,
    handleLocationChange,
    checkAll,
    checked,
    checkSelectAllDisabled,
    selectAllDisabled,
    handleShipAllChange,
    isBatchSelected,
    setIsBatchSelected,
    selectedLocation,
    isTemplateScreen,
    isIndependentProductGuide,
    handleCheckBoxSelection,
    moreTemplates,
    showDontShip,
    isOrderScreen,
    isCartScreen,
    isFromTemplates,
    isEquityTemplate,
    isTemplateDetail,
    items,
    itemBundles,
    itemImplant,
    itemInstrument,
    isConsignmentAdd,
    isEquityPage,
    isReviewSubmitScreenEquity,
    onBomClick,
    updateProductQuantity,
    fees,
    feesImplant,
    feesInstrument,
    isEquityScreen
}) => (
    <>
        {sets.length > 0 && (
            <CollapsableCard
                id="common-listViewContainer-template-sets"
                title={`${t('common.setsPascalCaseLabel')} (${sets?.length})`}
                onClick={() => toggleCard('sets', !expandedCard.sets)}
                isExpanded={expandedCard.sets}
                currentActivity
            >
                {expandedCard.sets && (
                    <>
                        {setImplant?.length > 0 && (
                            <>
                                <Header
                                    mbPaddingLeft={'20px'}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={'10px'}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    fontSize={'12px'}
                                    marginBottom={'7px'}
                                    background={'#EBEBEE 0% 0% no-repeat padding-box'}
                                >
                                    {t('common.tableView.implants')} ({setImplant?.length})
                                </Header>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={handleBundleSetItemClick}
                                    products={setImplant}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={checkSelectAllDisabled}
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isBatchSelected={isBatchSelected}
                                    setIsBatchSelected={setIsBatchSelected}
                                    selectedLocation={selectedLocation}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={isIndependentProductGuide}
                                    handleCheckBoxSelection={handleCheckBoxSelection}
                                    moreTemplates={moreTemplates}
                                    showDontShip={showDontShip}
                                    isOrderScreen={isOrderScreen}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isEquityTemplate={isEquityTemplate}
                                    isTemplateDetail={isTemplateDetail}
                                />
                            </>
                        )}
                        {setInstrument?.length > 0 && (
                            <>
                                <Header
                                    mbPaddingLeft={'20px'}
                                    mbWidth={'calc(100%)'}
                                    paddingLeft={'10px'}
                                    height={'38px'}
                                    mbHeight={'33px'}
                                    fontSize={'12px'}
                                    marginBottom={'7px'}
                                    background={'#EBEBEE 0% 0% no-repeat padding-box'}
                                >
                                    {t('common.tableView.instruments')} ({setInstrument?.length})
                                </Header>
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={handleBundleSetItemClick}
                                    products={setInstrument}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={checkSelectAllDisabled}
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isBatchSelected={isBatchSelected}
                                    setIsBatchSelected={setIsBatchSelected}
                                    selectedLocation={selectedLocation}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={isIndependentProductGuide}
                                    handleCheckBoxSelection={handleCheckBoxSelection}
                                    moreTemplates={moreTemplates}
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isEquityTemplate={isEquityTemplate}
                                    isTemplateDetail={isTemplateDetail}
                                />
                            </>
                        )}
                    </>
                )}
            </CollapsableCard>
        )}
        {(items.length > 0 || itemBundles?.length > 0) && (
                <CollapsableCard
                    id="common-listViewContainer-template-items"
                    title={`${t('common.itemsLabel')} (${
                        items.reduce(
                            (sum, currentItem) =>
                                sum + parseInt(currentItem.quantity || 0),
                            0
                        ) + getTotalCount(itemBundles)
                    })`}
                    onClick={() => toggleCard('items', !expandedCard.items)}
                    isExpanded={expandedCard.items}
                    currentActivity
                >
                    {expandedCard.items && (
                        <>
                            {itemImplant?.length > 0 && (
                                <>
                                    <Header
                                        mbPaddingLeft={'20px'}
                                        mbWidth={'calc(100%)'}
                                        paddingLeft={'10px'}
                                        height={'38px'}
                                        mbHeight={'33px'}
                                        fontSize={'12px'}
                                        marginBottom={'7px'}
                                        background={
                                            '#EBEBEE 0% 0% no-repeat padding-box'
                                        }
                                    >
                                        {t('common.tableView.implants')} (
                                        {itemImplant?.reduce(
                                            (sum, currentItem) =>
                                                sum +
                                                parseInt(currentItem.quantity || 0),
                                            0
                                        )})
                                    </Header>
                                    <ListView
                                        handleBundlePopup={handleBundlePopup}
                                        handleBundleSetItemClick={
                                            handleBundleSetItemClick
                                        }
                                        products={itemImplant}
                                        setsQuantityCheck={setsQuantityCheck}
                                        removeCount={removeCount}
                                        addCount={addCount}
                                        handleSetItemClick={handleSetItemClick}
                                        deleteProduct={deleteProduct}
                                        isShippingScreen={isShippingScreen}
                                        isReviewSubmitScreen={
                                            isReviewSubmitScreen
                                        }
                                        inventoryShipping={inventoryShipping}
                                        handleLocationChange={
                                            handleLocationChange
                                        }
                                        checkAll={checkAll}
                                        checked={checked}
                                        checkSelectAllDisabled={
                                            checkSelectAllDisabled
                                        }
                                        selectAllDisabled={selectAllDisabled}
                                        handleShipAllChange={
                                            handleShipAllChange
                                        }
                                        isItem={true}
                                        isTemplateScreen={isTemplateScreen}
                                        isIndependentProductGuide={
                                            isIndependentProductGuide
                                        }
                                        handleCheckBoxSelection={
                                            handleCheckBoxSelection
                                        }
                                        moreTemplates={moreTemplates}
                                        isConsignmentAdd={isConsignmentAdd}
                                        isEquityPage={isEquityPage}
                                        isReviewSubmitScreenEquity={
                                            isReviewSubmitScreenEquity
                                        }
                                        onBomClick={onBomClick}
                                        showDontShip={showDontShip}
                                        isCartScreen={isCartScreen}
                                        isFromTemplates={isFromTemplates}
                                        isEquityTemplate={isEquityTemplate}
                                        isTemplateDetail={isTemplateDetail}
                                        updateProductQuantity={
                                            updateProductQuantity
                                        }
                                    />
                                </>
                            )}
                            {itemInstrument?.length > 0 && (
                                <>
                                    <Header
                                        mbPaddingLeft={'20px'}
                                        mbWidth={'calc(100%)'}
                                        paddingLeft={'10px'}
                                        height={'38px'}
                                        mbHeight={'33px'}
                                        fontSize={'12px'}
                                        marginBottom={'7px'}
                                        background={
                                            '#EBEBEE 0% 0% no-repeat padding-box'
                                        }
                                    >
                                        {t('common.tableView.instruments')} (
                                        {itemInstrument?.reduce(
                                            (sum, currentItem) =>
                                                sum +
                                                parseInt(currentItem.quantity || 0),
                                            0
                                        )})
                                    </Header>
                                    <ListView
                                        handleBundlePopup={handleBundlePopup}
                                        handleBundleSetItemClick={
                                            handleBundleSetItemClick
                                        }
                                        products={itemInstrument}
                                        setsQuantityCheck={setsQuantityCheck}
                                        removeCount={removeCount}
                                        addCount={addCount}
                                        handleSetItemClick={handleSetItemClick}
                                        deleteProduct={deleteProduct}
                                        isShippingScreen={isShippingScreen}
                                        inventoryShipping={inventoryShipping}
                                        handleLocationChange={
                                            handleLocationChange
                                        }
                                        checkAll={checkAll}
                                        checked={checked}
                                        checkSelectAllDisabled={
                                            checkSelectAllDisabled
                                        }
                                        selectAllDisabled={selectAllDisabled}
                                        handleShipAllChange={
                                            handleShipAllChange
                                        }
                                        isItem={true}
                                        isTemplateScreen={isTemplateScreen}
                                        isIndependentProductGuide={
                                            isIndependentProductGuide
                                        }
                                        handleCheckBoxSelection={
                                            handleCheckBoxSelection
                                        }
                                        moreTemplates={moreTemplates}
                                        isConsignmentAdd={isConsignmentAdd}
                                        isEquityScreen={isEquityScreen}
                                        isEquityPage={isEquityPage}
                                        isReviewSubmitScreen={
                                            isReviewSubmitScreen
                                        }
                                        isReviewSubmitScreenEquity={
                                            isReviewSubmitScreenEquity
                                        }
                                        onBomClick={onBomClick}
                                        showDontShip={showDontShip}
                                        isCartScreen={isCartScreen}
                                        isFromTemplates={isFromTemplates}
                                        isEquityTemplate={isEquityTemplate}
                                        isTemplateDetail={isTemplateDetail}
                                        updateProductQuantity={
                                            updateProductQuantity
                                        }
                                    />
                                </>
                            )}
                            {itemBundles?.length > 0 && (
                                <>
                                    <Header
                                        mbPaddingLeft={'20px'}
                                        mbWidth={'calc(100%)'}
                                        paddingLeft={'10px'}
                                        height={'38px'}
                                        mbHeight={'33px'}
                                        fontSize={'12px'}
                                        marginBottom={'7px'}
                                        background={
                                            '#EBEBEE 0% 0% no-repeat padding-box'
                                        }
                                    >
                                        {t('common.tableView.bundles')} (
                                        {itemBundles?.reduce(
                                            (sum, currentItem) =>
                                                sum +
                                                parseInt(
                                                    currentItem.quantity || 0
                                                ),
                                            0
                                        )}
                                        )
                                    </Header>
                                    <ListView
                                        handleBundlePopup={handleBundlePopup}
                                        handleBundleSetItemClick={
                                            handleBundleSetItemClick
                                        }
                                        products={itemBundles}
                                        setsQuantityCheck={setsQuantityCheck}
                                        removeCount={removeCount}
                                        addCount={addCount}
                                        handleSetItemClick={handleSetItemClick}
                                        deleteProduct={deleteProduct}
                                        isShippingScreen={isShippingScreen}
                                        isReviewSubmitScreen={
                                            isReviewSubmitScreen
                                        }
                                        inventoryShipping={inventoryShipping}
                                        handleLocationChange={
                                            handleLocationChange
                                        }
                                        checkAll={checkAll}
                                        checked={checked}
                                        checkSelectAllDisabled={
                                            checkSelectAllDisabled
                                        }
                                        selectAllDisabled={selectAllDisabled}
                                        handleShipAllChange={
                                            handleShipAllChange
                                        }
                                        isItem={true}
                                        isTemplateScreen={isTemplateScreen}
                                        isIndependentProductGuide={
                                            isIndependentProductGuide
                                        }
                                        handleCheckBoxSelection={
                                            handleCheckBoxSelection
                                        }
                                        moreTemplates={moreTemplates}
                                        isConsignmentAdd={isConsignmentAdd}
                                        isEquityPage={isEquityPage}
                                        isReviewSubmitScreenEquity={
                                            isReviewSubmitScreenEquity
                                        }
                                        onBomClick={onBomClick}
                                        showDontShip={showDontShip}
                                        isCartScreen={isCartScreen}
                                        isFromTemplates={isFromTemplates}
                                        isBundleView={true}
                                        isEquityTemplate={isEquityTemplate}
                                        isTemplateDetail={isTemplateDetail}
                                        updateProductQuantity={
                                            updateProductQuantity
                                        }
                                    />
                                </>
                            )}
                        </>
                    )}
                </CollapsableCard>
            )}
        {fees.length > 0 && (
                <CollapsableCard
                    id="common-listViewContainer-template-fees"
                    title={`${t('common.feeLabel')} (${fees?.length})`}
                    onClick={() => toggleCard('fees', !expandedCard.fees)}
                    isExpanded={expandedCard.fees}
                    currentActivity
                >
                    {expandedCard.fees && (
                        <>
                            {feesImplant?.length > 0 && (
                                <ListView
                                    handleBundlePopup={handleBundlePopup}
                                    handleBundleSetItemClick={
                                        handleBundleSetItemClick
                                    }
                                    products={feesImplant}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={removeCount}
                                    addCount={addCount}
                                    handleSetItemClick={handleSetItemClick}
                                    deleteProduct={deleteProduct}
                                    isShippingScreen={isShippingScreen}
                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                    inventoryShipping={inventoryShipping}
                                    handleLocationChange={handleLocationChange}
                                    checkAll={checkAll}
                                    checked={checked}
                                    checkSelectAllDisabled={
                                        checkSelectAllDisabled
                                    }
                                    selectAllDisabled={selectAllDisabled}
                                    handleShipAllChange={handleShipAllChange}
                                    isBatchSelected={isBatchSelected}
                                    setIsBatchSelected={setIsBatchSelected}
                                    selectedLocation={selectedLocation}
                                    isTemplateScreen={isTemplateScreen}
                                    isIndependentProductGuide={
                                        isIndependentProductGuide
                                    }
                                    handleCheckBoxSelection={
                                        handleCheckBoxSelection
                                    }
                                    isOrderScreen={isOrderScreen}
                                    isEquityPage={isEquityPage}
                                    onBomClick={onBomClick}
                                    showDontShip={showDontShip}
                                    isCartScreen={isCartScreen}
                                    isFromTemplates={isFromTemplates}
                                    isTemplateDetail={isTemplateDetail}
                                />
                            )}
                            {feesInstrument?.length > 0 && (
                                <>
                                    <ListView
                                        handleBundlePopup={handleBundlePopup}
                                        handleBundleSetItemClick={
                                            handleBundleSetItemClick
                                        }
                                        products={feesInstrument}
                                        setsQuantityCheck={setsQuantityCheck}
                                        removeCount={removeCount}
                                        addCount={addCount}
                                        handleSetItemClick={handleSetItemClick}
                                        deleteProduct={deleteProduct}
                                        isShippingScreen={isShippingScreen}
                                        isReviewSubmitScreen={
                                            isReviewSubmitScreen
                                        }
                                        inventoryShipping={inventoryShipping}
                                        handleLocationChange={
                                            handleLocationChange
                                        }
                                        checkAll={checkAll}
                                        checked={checked}
                                        checkSelectAllDisabled={
                                            checkSelectAllDisabled
                                        }
                                        selectAllDisabled={selectAllDisabled}
                                        handleShipAllChange={
                                            handleShipAllChange
                                        }
                                        isBatchSelected={isBatchSelected}
                                        setIsBatchSelected={setIsBatchSelected}
                                        selectedLocation={selectedLocation}
                                        isTemplateScreen={isTemplateScreen}
                                        isIndependentProductGuide={
                                            isIndependentProductGuide
                                        }
                                        handleCheckBoxSelection={
                                            handleCheckBoxSelection
                                        }
                                        isOrderScreen={isOrderScreen}
                                        isConsignmentAdd={isConsignmentAdd}
                                        isEquityScreen={isEquityScreen}
                                        isEquityPage={isEquityPage}
                                        isReviewSubmitScreenEquity={
                                            isReviewSubmitScreenEquity
                                        }
                                        onBomClick={onBomClick}
                                        showDontShip={showDontShip}
                                        isCartScreen={isCartScreen}
                                        isFromTemplates={isFromTemplates}
                                        isTemplateDetail={isTemplateDetail}
                                    />
                                </>
                            )}
                        </>
                    )}
                </CollapsableCard>
            )}
    </>
);

export default ListViewCards;
